import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsLinkModule } from '@skyeng/libs/shared/ui-kit-v2/link';
import { CommunicationsMessageComponent } from './components/communication-message/communication-message';
import { provideVimCoreUserConfig, VimCoreUserModule } from '@skyeng/libs/vimbox-core/user';
import { QuillModule } from 'ngx-quill';
import { TranslocoModule } from '@ngneat/transloco';
import { CommunicationComponent } from './components/communication/communication';
import { SkyproMessagesModule } from '@skyeng/libs/skypro/messages';
import { DsButtonModule } from '@skyeng/libs/shared/ui-kit-v2/button';
import { CommunicationsFormComponent } from './components/communication-form/communication-form';
import { DsSpinnerModule } from '@skyeng/libs/shared/ui-kit-v2/spinner';
import { TypografModule } from '@skyeng/libs/skypro/misc';
import { DsIconModule } from '@skyeng/libs/shared/ui-kit-v2/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SkyI18nModule } from '@skyeng/libs/shared/i18n';
import { CommunicationFormService } from './components/communication-form/communication-form.service';
import { CommunicationService } from './service/communication.service';
import { CommunicationsThreadComponent } from './components/communication-thread/communication-thread';
import { LastNUniqAuthorsPipe } from './pipe/last-n-uniq-els';
import { CommunicationLikeComponent } from './components/communication-like/communication-like';
import { CommunicationLikeService } from './service/communication-like.service';
import { CommunicationReportDialogComponent } from './components/communication-report-dialog/communication-report-dialog';
import { DsDialogModule } from '@skyeng/libs/shared/ui-kit-v2/dialog';
import { CommunicationLikeDirective } from './components/communication-like/communication-like.directive';
import { CommunicationFlatViewComponent } from './components/communication-flat-view/communication-flat-view';
import { CommunicationFlatViewMessageComponent } from './components/communication-flat-view-message/communication-flat-view-message';

@NgModule({
  imports: [
    CommonModule,
    VimCoreUserModule,
    QuillModule.forRoot(),
    TranslocoModule,
    DsLinkModule,
    DsButtonModule,
    DsSpinnerModule,
    TypografModule,
    SkyproMessagesModule,
    DsIconModule,
    MatMenuModule,
    SkyI18nModule,
    DsDialogModule,
    CommunicationsThreadComponent,
    CommunicationsMessageComponent,
    CommunicationsFormComponent,
    CommunicationComponent,
    CommunicationFlatViewComponent,
    CommunicationFlatViewMessageComponent,
    LastNUniqAuthorsPipe,
    CommunicationLikeComponent,
    CommunicationReportDialogComponent,
    CommunicationLikeDirective,
  ],
  providers: [
    provideVimCoreUserConfig(),
    {
      provide: CommunicationFormService,
      useExisting: CommunicationService,
    },
    {
      provide: CommunicationLikeService,
      useExisting: CommunicationService,
    },
  ],
  exports: [
    CommunicationsThreadComponent,
    CommunicationsMessageComponent,
    CommunicationsFormComponent,
    CommunicationComponent,
    CommunicationFlatViewComponent,
    CommunicationFlatViewMessageComponent,
    CommunicationLikeComponent,
    CommunicationReportDialogComponent,
  ],
})
export class SkyproCommunicationsModule {}
